import React from "react"


function thankyou() {

    return(
        <div>
            <h1>Thank you!</h1>
            <p>To filled up the form</p>
        </div>
    )
}


export default thankyou